import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthMutation } from '../auth-http-client';
import { addAccountResponseSchema } from '../types';

export type AddAccountMutationParams = {
	name: string;
	parentId: number;
	currencies: string[];
	note: string;
	permissions: {
		canCreateSubAccounts: boolean;
		canWriteUsers: boolean;
		canEditLimits: boolean;
		canEditGameSettings: boolean;
		canWriteCashdesks: boolean;
		canBlockGames: boolean;
	};
};

export const createAddAccountMutation = () =>
	createAuthMutation({
		params: declareParams<AddAccountMutationParams>(),
		request: {
			method: 'POST',
			url: '/account',
			body: (data) => data,
		},
		response: {
			contract: zodContract(addAccountResponseSchema),
		},
	});
